import React, { useRef, useState } from "react";

import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import { notifyError, notifySucces } from "../../utils/notifications";
import { useVersion } from "../../Context/hasBetaActiveContext";
import { usePopup } from "../../Context/hasPopupActiveContext";
import { useClient } from "../../hooks/ClientProvider";
import { useAuth } from "../../hooks/AuthProvider";
import * as S from "./styles";
import LoadingElevaty from "../../components/LoadingElevaty";
import { TSSOError } from "../../types/errorPattern";

const RedirectSSO = () => {
  const [isLoading, setIsLoading] = useState(true);

  const { signInSSO } = useAuth();

  const { keycloak } = useKeycloak();
  const hasSyncedRef = useRef(false);
  const navigate = useNavigate();
  const { fetchHasBetaActive } = useVersion();
  const { fetchHasPopupActive } = usePopup();
  const { clearClient } = useClient() as { clearClient: () => void };

  const error = localStorage.getItem("SSO_ERROR");

  const ssoLogin = async () => {
    if (!keycloak?.authenticated || !keycloak.token) return;

    if (hasSyncedRef.current) return;

    hasSyncedRef.current = true;

    try {
      setIsLoading(true);
      await signInSSO(keycloak.token);

      if (
        JSON.parse(
          localStorage.getItem("@SacRPE:allowAccess") as string
        ) === false
      ) {
        notifyError("Acesso negado");
        navigate("/access-denied");
        return;
      }

      navigate("/home");
      notifySucces("Logado com sucesso");
      await fetchHasPopupActive();
      await fetchHasBetaActive();
      clearClient();
    } catch (err) {
      const { response } = err as TSSOError;
      const errorMsg = response?.data?.message || "Erro no SSO login";

      hasSyncedRef.current = false;
      localStorage.setItem("SSO_ERROR", errorMsg);

      await keycloak.logout({
        redirectUri: `${window.location.origin}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (
    keycloak?.authenticated &&
    keycloak.token &&
    !hasSyncedRef.current &&
    !error
  ) {
    ssoLogin();
  }
  return (
    <>
      {isLoading && (
        <S.WrapperNewLoading>
          <LoadingElevaty />
        </S.WrapperNewLoading>
      )}
    </>
  );
};

export default RedirectSSO;
